import {
	UseBaseQueryOptions,
	keepPreviousData,
	useQuery,
} from '@tanstack/react-query'
import { getOverallAnalyticsCumulative } from '../../services'
import { DashboardKeys } from '@/modules/dashboard/keys'
import {
	GetOverallAnalyticsCumulativeResponse,
	GetOverallAnalyticsRequest,
} from '@/modules/dashboard/type'

export default function useQueryGetOverallAnalyticsCumulative(
	payload: GetOverallAnalyticsRequest,
	props?: UseBaseQueryOptions<GetOverallAnalyticsCumulativeResponse>,
) {
	return useQuery({
		queryKey: [DashboardKeys.OverallAnalyticsCumulative, payload],
		queryFn: () => getOverallAnalyticsCumulative(payload),
		placeholderData: keepPreviousData,
		...props,
	})
}
